import { FontWeights, makeStyles } from '@fluentui/react';

export const useCommonStyles = makeStyles((theme) => ({
  semibold: {
    fontWeight: FontWeights.semibold,
  },
  bold: {
    fontWeight: FontWeights.bold,
  },
  warning: {
    color: theme.palette.yellowDark,
  },
  semilight: {
    fontWeight: FontWeights.semilight,
  },
  light: {
    fontWeight: FontWeights.light,
  },
  noScroll: {
    overflow: 'hidden',
  },
  listHeaderContainer: {
    padding: '25px 25px 25px 25px',
  },
  listTitleContainer: {
    height: 32,
  },
  colorThemePrimary: {
    color: theme.palette.themePrimary,
  },
  colorWhite: {
    color: theme.palette.white,
  },
  colorStaticWhite: {
    color: 'white',
  },
  themeGreen: {
    color: theme.palette.green,
  },
  colorThemeRed: {
    color: theme.palette.red,
  },
  contentColumnAlignRight: {
    display: 'block',
    textAlign: 'right',
  },
  headerContainer: {
    color: theme.palette.themePrimary,
    marginTop: -20,
  },
  urgentBox: {
    color: theme.palette.redDark,
    fontSize: 20,
  },
  flexFull: { flex: 1 },
  flexHalf: { flex: 0.5 },
  flexThird: { flex: 0.3 },
  urgentRow: {
    border: `1px solid ${theme.palette.redDark}22`,
    borderLeft: `5px solid ${theme.palette.redDark}99`,
    backgroundColor: `${theme.palette.redDark}09`,
    ':hover': {
      backgroundColor: `${theme.palette.redDark}22`,
    },
  },
  badge: {
    height: 20,
    zIndex: 1,
    position: 'absolute',
    width: 20,
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: 10,
    top: 10,
    right: 0,
    transform: 'scale(1) translate(50%, -50%)',
    transformOrigin: '100% 0%',
    backgroundColor: theme.palette.themePrimary,
  },
  noSelect: {
    userSelect: 'none',
  },
  urgencyColumn: {
    paddingLeft: '0px !important',
  },
}));
